var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "sticky-footer bg-white" }, [
    _c("div", { staticClass: "container my-auto" }, [
      _c("div", { staticClass: "copyright text-center my-auto" }, [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.Lang.get("messages.copyrights")) },
        }),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { target: "_blank", href: "https://mazaya.com.kw" } },
          [_vm._v("Mazaya")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }